/* Condenses Menu Alpha while scrolled: logo drops to half size and the bar
   tightens, restoring at the top. Separate shrink/expand thresholds prevent
   flicker at the boundary (the bar's own height change shifts the page). */
class EscMenuAlpha extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.section-menu-alpha');
    this.bar = this.querySelector('.esc-menu-alpha__bar');
    /* Retract only where another bar is genuinely on the page to take over
       navigation. Both takeover bars are rendered server-side with their own
       visibility rules, so checking the DOM (not the settings) keeps a reader
       from ever being left with no navigation at all.
         - Menu Beta and the Support Menu sit directly beneath Alpha in the
           header group, so they are already at the top and Alpha can lift away
           on a plain scroll offset.
         - The Machine Menu is a page section further down the page, so Alpha
           holds its ground until that bar has actually climbed up to it. */
    const headerBar = document.querySelector('.esc-menu-beta, .esc-support-menu');
    /* a Machine Menu only counts as a takeover when it is set to pin — one that
       scrolls away with the page would leave nothing behind to navigate with */
    const machineMenu = headerBar ? null : document.querySelector('esc-machine-menu[data-sticky="true"]');
    this.takeoverIsInline = machineMenu !== null;
    this.takeoverSection = machineMenu ? machineMenu.closest('.shopify-section') : null;
    this.canRetract = this.dataset.retract === 'true' && (headerBar !== null || machineMenu !== null);
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  /* true = lift out of view, false = drop back, null = leave as it is (the gap
     between the two thresholds, which stops the bar flickering at the boundary) */
  retractIntent(y) {
    if (this.takeoverIsInline) {
      const gap = this.takeoverSection.getBoundingClientRect().top - this.bar.offsetHeight;
      if (gap <= 0) return true;
      if (gap > 24) return false;
      return null;
    }
    if (y > 90) return true;
    if (y < 30) return false;
    return null;
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      if (y > 90) {
        this.classList.add('esc-menu-alpha--condensed');
      } else if (y < 30) {
        this.classList.remove('esc-menu-alpha--condensed');
      }

      if (this.section) {
        const retract = this.canRetract ? this.retractIntent(y) : false;
        if (retract !== null) {
          this.section.classList.toggle('section-menu-alpha--retracted', retract);
        }
      }
      this.ticking = false;
    });
  }
}

if (!customElements.get('esc-menu-alpha')) {
  customElements.define('esc-menu-alpha', EscMenuAlpha);
}

/* Adding to cart should not pop any window: neuter the cart notification's
   open() so the add still happens over AJAX and re-renders the cart icon
   bubble (which triggers the pulse), but no panel appears. */
customElements.whenDefined('cart-notification').then(() => {
  document.querySelectorAll('cart-notification').forEach((notification) => {
    notification.open = () => {};
  });
});
